export default __webpack_public_path__ + "static/media/mehul.9a6ffad1.jpeg";